import VueFormulate from 'vue3-formulate'
import WAFormulateErrors from '#common/components/Error/WAFormulateErrors'
import FlexSelect from '#common/components/FlexSelect/FlexSelect'

export default defineNuxtPlugin({
  setup(nuxt) {
    const { vueApp } = nuxt
    const formulate = new VueFormulate()

    vueApp.component('WAFormulateErrors', WAFormulateErrors)
    vueApp.component('FlexSelect', FlexSelect)
    vueApp.use(formulate, {
      locales: {
        en: {
          required({
            name,
            vm: {
              $attrs: { placeholder },
              $props: { label } = {},
            },
          }) {
            /* Display a human-readable label if possible. */
            name = label || placeholder || name
            return `${name.replace(/\*\s*$/, '').trim()} is required.`
          },
        },
      },
      slotComponents: {
        errors: 'WAFormulateErrors',
      },
      library: {
        flexSelect: {
          classification: 'text',
          component: 'FlexSelect',
          slotProps: {
            component: [
              'searchable',
              'clearable',
              'labelFieldNames',
              'valueKey',
              'labelKey',
              'optionMapper',
            ],
          },
        },
      },
    })

    return {
      provide: {
        formulate,
      },
    }
  },
})
